import CloseIcon from "@mui/icons-material/Close";
import {
    Button,
    CircularProgress,
    DialogContent,
    FormControl,
    FormHelperText,
    IconButton,
    TextField
} from "@mui/material";
import { useEffect, useState } from "react";
import { StyledDialog } from "../../styled/dialog";
import CustomDialog from "./customDialog";

const AdminChangePasswordDialog = ({
    open,
    onClose,
    onSubmit,
    loading,
}) => {
    const [password, setPassword] = useState("");
    const [errors, setErrors] = useState([]);

    useEffect(() => {
        if (!open) {
            setPassword("");
            setErrors([]);
        }
    }, [open]);

    const validatePassword = (value) => {
        const newErrors = [];

        if (!value) {
            newErrors.push("Campo requerido");
        } else {
            if (value.length < 8) {
                newErrors.push("La contraseña debe tener al menos 8 caracteres");
            }
            if (value.length > 32) {
                newErrors.push("Debe tener 32 caracteres o menos");
            }
            if (!/^(?=.*[a-zA-Z])(?=.*[0-9])[a-zA-Z0-9~!@#$%^&*_\-+=|(){}[\]:;'<>,.?/]+$/.test(value)) {
                newErrors.push("La contraseña debe contener números y letras");
            }
        }

        setErrors(newErrors);
        return newErrors.length === 0;
    };

    const handlePasswordChange = (e) => {
        const value = e.target.value;
        setPassword(value);
        validatePassword(value);
    };

    const handleSubmit = () => {
        if (validatePassword(password)) {
            onSubmit(password);
        }
    };

    const handleClose = () => {
        setPassword("");
        setErrors([]);
        onClose();
    };

    const isValid = password && errors.length === 0;

    return (
        <CustomDialog
            open={open}
            onClose={handleClose}
            maxWidth="xs"
            fullWidth
        >
            <StyledDialog.MuiDialogTitle disableTypography>
                <StyledDialog.Title>Editar Contraseña</StyledDialog.Title>
                <IconButton onClick={handleClose} size="small">
                    <CloseIcon />
                </IconButton>
            </StyledDialog.MuiDialogTitle>
            <DialogContent>
                <FormControl fullWidth error={errors.length > 0} sx={{ mt: 1 }}>
                    <TextField
                        label="Contraseña"
                        type="password"
                        value={password}
                        onChange={handlePasswordChange}
                        error={errors.length > 0}
                        fullWidth
                        variant="outlined"
                        autoComplete="new-password"
                        name="new-password-admin"
                    />
                    {errors.length > 0 && (
                        <FormHelperText>{errors[0]}</FormHelperText>
                    )}
                </FormControl>
            </DialogContent>
            <StyledDialog.Actions>
                <Button onClick={handleClose} color="primary">
                    Cancelar
                </Button>
                <Button
                    onClick={handleSubmit}
                    color="primary"
                    variant="contained"
                    disabled={!isValid || loading}
                >
                    {loading ? <CircularProgress size={24} color="inherit" /> : "Aceptar"}
                </Button>
            </StyledDialog.Actions>
        </CustomDialog>
    );
};

export default AdminChangePasswordDialog;
